import React from 'react';
import { connect } from 'react-redux';
import {Menu, MenuItem, AsyncTypeahead} from 'react-bootstrap-typeahead';
import {groupBy, map} from 'lodash';
import { IsMLSNumber, GetSectionCustomizationOptions } from 'components/util';

//const SiteCustomizationOptions = GetSiteCustomizationOptions();
const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

/*const MenuDivider = props => <li className="divider" role="separator" />;*/
const MenuHeader = props => <li {...props} className="dropdown-header" style={{color: "#ccc", backgroundColor: "#777" }} />;

class SuperAutoComplete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            countryCode: 'USA',
            options: [],
            defaultSelected: (props.defaultSelected) ? props.defaultSelected : null,
            recentSearchClicked: props.recentSearchClicked,
            RegionalBoardCode: (props.RegionalBoardCode && props.RegionalBoardCode !== "") ? props.RegionalBoardCode : "",
            IncludeMLSNumber: (props.IncludeMLSNumber !== undefined && props.IncludeMLSNumber !== null && props.IncludeMLSNumber !== "") ? props.IncludeMLSNumber : 0,
            IncludeStreetAddress: (props.IncludeStreetAddress !== undefined && props.IncludeStreetAddress !== null && props.IncludeStreetAddress !== "") ? props.IncludeStreetAddress : 1,
            IncludeCity: (props.IncludeCity !== undefined && props.IncludeCity !== null && props.IncludeCity !== "") ? props.IncludeCity : 0,
            IncludePostal: (props.IncludePostal !== undefined && props.IncludePostal !== null && props.IncludePostal !== "") ? props.IncludePostal : 1,
            ReturnMLSNumber: (props.ReturnMLSNumber !== undefined && props.ReturnMLSNumber !== null && props.ReturnMLSNumber !== "") ? props.ReturnMLSNumber : 0,
            IncludeTown: (props.IncludeTown !== undefined && props.IncludeTown !== null && props.IncludeTown !== "") ? props.IncludeTown : 0,
            IncludeCounty: (props.IncludeCounty !== undefined && props.IncludeCounty !== null && props.IncludeCounty !== "") ? props.IncludeCounty : 0,
            IncludeVillage: (props.IncludeVillage !== undefined && props.IncludeVillage !== null && props.IncludeVillage !== "") ? props.IncludeVillage : 0,
            FilterStatus: (props.FilterStatus && props.FilterStatus !== "") ? props.FilterStatus : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") ? CommonCustomizationOptions.DefaultAutoSuggestStatuses : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultStatuses && CommonCustomizationOptions.DefaultStatuses !== "") ? CommonCustomizationOptions.DefaultStatuses : "active")),
            FilterPropertyType: (props.FilterPropertyType && props.FilterPropertyType !== "") ? props.FilterPropertyType : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") ? CommonCustomizationOptions.DefaultPropertyTypes : "sf"),
            PageSize: (props.PageSize && props.PageSize !== "") ? props.PageSize : 5,
            isLoading: false
        }

        this.renderOptions = this.renderOptions.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.clear = this.clear.bind(this);
    }

    componentWillReceiveProps(nextProps){
        //this.setState({defaultSelected: nextProps.defaultSelected, recentSearchClicked: nextProps.recentSearchClicked});        

        var tState = Object.assign({}, this.state);
        tState.RegionalBoardCode = (nextProps.RegionalBoardCode && nextProps.RegionalBoardCode !== "") ? nextProps.RegionalBoardCode : "";
        tState.IncludeMLSNumber = (nextProps.IncludeMLSNumber !== undefined && nextProps.IncludeMLSNumber !== null && nextProps.IncludeMLSNumber !== "") ? nextProps.IncludeMLSNumber : 0;
        tState.IncludeStreetAddress = (nextProps.IncludeStreetAddress !== undefined && nextProps.IncludeStreetAddress !== null && nextProps.IncludeStreetAddress !== "") ? nextProps.IncludeStreetAddress : 1;
        tState.IncludeCity = (nextProps.IncludeCity !== undefined && nextProps.IncludeCity !== null && nextProps.IncludeCity !== "") ? nextProps.IncludeCity : 0;
        tState.IncludePostal = (nextProps.IncludePostal !== undefined && nextProps.IncludePostal !== null && nextProps.IncludePostal !== "") ? nextProps.IncludePostal : 1;
        tState.ReturnMLSNumber = (nextProps.ReturnMLSNumber !== undefined && nextProps.ReturnMLSNumber !== null && nextProps.ReturnMLSNumber !== "") ? nextProps.ReturnMLSNumber : 0;
        tState.IncludeTown = (nextProps.IncludeTown !== undefined && nextProps.IncludeTown !== null && nextProps.IncludeTown !== "") ? nextProps.IncludeTown : 0;
        tState.IncludeCounty = (nextProps.IncludeCounty !== undefined && nextProps.IncludeCounty !== null && nextProps.IncludeCounty !== "") ? nextProps.IncludeCounty : 0;
        tState.IncludeVillage = (nextProps.IncludeVillage !== undefined && nextProps.IncludeVillage !== null && nextProps.IncludeVillage !== "") ? nextProps.IncludeVillage : 0;
        tState.FilterStatus = (nextProps.FilterStatus && nextProps.FilterStatus !== "") ? nextProps.FilterStatus : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") ? CommonCustomizationOptions.DefaultAutoSuggestStatuses : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultStatuses && CommonCustomizationOptions.DefaultStatuses !== "") ? CommonCustomizationOptions.DefaultStatuses : "active"));
        //tState.FilterPropertyType = (nextProps.FilterPropertyType && nextProps.FilterPropertyType !== "") ? nextProps.FilterPropertyType : "sf";
        tState.FilterPropertyType = (nextProps.FilterPropertyType && nextProps.FilterPropertyType !== "") ? nextProps.FilterPropertyType : ((CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") ? CommonCustomizationOptions.DefaultPropertyTypes : "sf");
        tState.PageSize = (nextProps.PageSize && nextProps.PageSize !== "") ? nextProps.PageSize : 5;

        tState.defaultSelected = nextProps.defaultSelected;
        tState.recentSearchClicked = nextProps.recentSearchClicked;

        this.setState(tState);

        // hack to display defaultSelected when recent search is clicked
        /* if (nextProps.recentSearchClicked)
            this._instance.setState({selected: [nextProps.defaultSelected]}); */
        /* if (nextProps.recentSearchClicked && this._typeahead && this._typeahead.getInstance()){
            this._typeahead.getInstance().setState({selected: [nextProps.defaultSelected]});
        } */

    }

    renderOptions(results, menuProps) {
        if(!this.state.isLoading && !results.length) return null;

        let idx = 0;
        const grouped = groupBy(results, r => r.header);
        const items = Object.keys(grouped).sort((a, b) => {if (a>b) return -1; else if (a<b) return 1; else return 0;}).map(header => {
            return [
                /*!!idx && <MenuDivider key={`${header}-divider`} />,*/
                !!idx,
                <MenuHeader key={`${header}-header`}>
                    {header}
                </MenuHeader>,
                map(grouped[header], state => {
                    const item =
                        <MenuItem key={idx} option={state} position={idx}>
                            {state.text}
                        </MenuItem>;

                    idx++;
                    return item;
                }),
            ];
        });

        return <Menu {...menuProps}>{items}</Menu>;
    }

    handleSearch(query) {
        const {RegionalBoardCode, IncludeMLSNumber, IncludeStreetAddress, IncludeCity,
            IncludePostal, ReturnMLSNumber, IncludeTown, IncludeCounty, IncludeVillage,
            FilterStatus, PageSize, FilterPropertyType } = this.state;

        var self = this;

        if (!query) {
            self.setState({options: [], isLoading: false});
            return;
        }

        var urlPre = window.sessionStorage.getItem("RootAPI") + "suggest/get?text=" + query;
        var urlPost = "&mlsnumber=" + IncludeMLSNumber +
            "&streetaddress=" + IncludeStreetAddress +
            "&city=" + IncludeCity +
            "&postal=" + IncludePostal +
            "&valuemlsnumber=" + ReturnMLSNumber +
            "&nhtown=" + IncludeTown +
            "&nhcounty=" + IncludeCounty +
            "&nhvillage=" + IncludeVillage +
            "&status=" + FilterStatus +
            "&propertytype=" + FilterPropertyType +
            "&pagesize=" + PageSize;
        if(RegionalBoardCode && RegionalBoardCode !== "") urlPost = urlPost + "&regionalboardcode=" + RegionalBoardCode;

        self.setState({isLoading: true});
        var url = urlPre + urlPost;
        var resultAll = fetch(url,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                },
                method: "GET"
            })
            .then(resp => resp.json())
            .then(json => {

                var cityItems = [];

                //json.suggestions.slice(0,5).forEach(function(obj){
                json.forEach(function(obj){
                    var tmp = {};                    
                    tmp.header = obj.GroupDisplayName;                       
                    tmp.searchText = query;
                    tmp.text = obj.Text;
                    tmp.value = (obj.aText && obj.aText !== "") ? obj.aText : obj.Value;
                    tmp.paramname = obj.GroupName;
                    
                    // Add if it doesn't exist
                    //var existsIn = cityItems.filter(w=>w.text === tmp.text);
                    //if (existsIn === undefined || existsIn.length === 0) { 
                        cityItems.push(tmp); 
                    //}
                });

                return cityItems;
            });
        
        Promise.all([resultAll]).then(values => {
            var resultFull = values[0];

            self.setState({options: resultFull, isLoading: false});
        });

    }

    handleSubmit(e) {

        var self = this;

        if(e !== undefined && e !== null && e.length > 0 &&
            e[0] !== undefined && e[0] !== null &&
            e[0].text !== undefined && e[0].text !== null && e[0].text !== "") {
            var obj = {};
            if(self.props.handleAutoComplete){
                setTimeout(function() { 
                    obj.SearchedText = e[0].value;
                    if(e[0].paramname && e[0].paramname !== "") obj.SearchedParam = e[0].paramname;
                    self.props.handleAutoComplete(obj);
                    //if(self._typeahead && self.props.hideFocus) self._typeahead.getInstance().blur();
                    if(self._typeahead && self.props.hideFocus) self._typeahead.blur();
                }, 500);                
            }
        }
    }

    onInputChange(e) {
        if(this.props.onInputChange) {
            this.props.onInputChange(e);
        }
    }
    
    onFocus(e) {
        if(this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onBlur(e) {
        if(this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    clear(){
        if(this._typeahead) {
            //this._typeahead.getInstance().clear();
            this._typeahead.clear();
        }
    }

    onKeyDown = (event) => {
        if(event && event.key === "Enter"){
            event.preventDefault();
            if(this.props.onEnterPressed){
                this.props.onEnterPressed();
            }
        }
    }

    render() {

        var minLength = 3;
        /* if(this.state !== null &&
                this.state.defaultSelected !== undefined &&
                this.state.defaultSelected !== null &&                
                //this.state.defaultSelected.match("^#"))
                this.state.defaultSelected.indexOf("#") === 0)
        {
            minLength = 255;
        } */
        if(this.state !== null &&
            this.state.defaultSelected !== undefined &&
            this.state.defaultSelected !== null &&                
            IsMLSNumber(this.state.defaultSelected) &&
            (this.state.ReturnMLSNumber !== 1 && this.state.ReturnMLSNumber !== "1"))
        {
            //minLength = 255;
        }

        var config = {
            className: this.props.className ? "autocomp " + this.props.className : "autocomp",
            minLength: minLength,
            align: "justify",
            maxWidth: "220px",
            options: this.state.options,
            isLoading: this.state.isLoading
        };
        
        if(this.state.defaultSelected !== undefined && this.state.defaultSelected !== null && this.state.defaultSelected !== ""){
            config.defaultSelected = [this.state.defaultSelected];
        }
        else{
            config.placeholder = this.props.placeholder || "Search";
        }

        return (
            <AsyncTypeahead
                ref={ref => this._typeahead = ref}
                id={this.props.id}
                //ref={(component) => this._instance = component ? component.getInstance() : this._typeahead }
                //ref={(component) => this._instance = component ? component.getInstance() : this._instance }
                {...config}
                clearButton
                labelKey="text"
                emptyLabel={this.state.isLoading ? "Searching..." : ""}
                //filterBy={['searchText', 'text', 'value']}
                useCache={false}
                filterBy={() => true}
                onSearch={this.handleSearch}
                renderMenu={this.renderOptions}
                onChange={this.handleSubmit}
                onInputChange={this.onInputChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                onKeyDown={this.onKeyDown}
                />
        );
    }
}

const mapStateToProps = (state, props) => ({
    searchBounds: state.settings.data['AutocompleteSearchBounds'],
    defaultMapLocation: state.settings.data['DefaultMapLocation']
});

export default connect(mapStateToProps, null, null, { withRef: true })(SuperAutoComplete);